// extracted by mini-css-extract-plugin
export default {"cls1":"T5qnQgZ1ppwZWEJ7eCQc","cls2":"s9jXmsxZdVKBmis5Mf5X T5qnQgZ1ppwZWEJ7eCQc"};